import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { getToken } from '@/utils/utils'

Vue.use(Router)

const MainPage = () => import(/* 根页面 */ '@/views/')
const HomePage = () => import(/* 主页 */ '@/views/home')
const Auth = () => import(/* 授权模块 */ '@/views/auth')
const AuthLogin = () => import(/* 登录 */ '@/views/auth/login')
const AuthOrganization = () => import(/* 选择机构 */ '@/views/auth/organization')
const AuthService = () => import(/* 选择机构 */ '@/views/auth/service')

const Meal = () => import(/* 套餐 */ '@/views/meal')
const MealList = () => import(/* 套餐列表 */ '@/views/meal/list')
const MealDetail = () => import(/* 套餐详情 */ '@/views/meal/detail')
const MealMedicalItem = () => import(/* 体检项目列表 */ '@/views/meal/medicalItem')
const MealMedicalDetail = () => import(/* 体检项目详情 */ '@/views/meal/medicalDetail')
const MealCheckItem = () => import(/* 检查项目列表 */ '@/views/meal/checkItem')

// const Report = () => import(/* 报告 */ '@/views/report')
// const ReportList = () => import(/* 报告列表 */ '@/views/report/list')
// const ReportDetail = () => import(/* 报告详情 */ '@/views/report/detail')
const Reservation = () => import(/* 预约 */ '@/views/reservation')
const ReservationList = () => import(/* 预约列表 */ '@/views/reservation/list')
const ReservationDetail = () => import(/* 预约列表 */ '@/views/reservation/detail')

// const Customer = () => import(/* 客户 */ '@/views/customer')
// const CustomerList = () => import(/* 客户 */ '@/views/customer/list')

const Order = () => import(/* 财务 */ '@/views/order')
const OrderList = () => import(/* 订单列表 */ '@/views/order/list')
const OrderDetail = () => import(/* 订单详情 */ '@/views/order/detail')
const OrderHistory = () => import(/* 订单交易记录 */ '@/views/order/history')

// const Setting = () => import(/* 设置 */ '@/views/setting')
// const SettingHospital = () => import(/* 医院信息 */ '@/views/setting/hospital')
// const SettingHospitalBaseInfo = () => import(/* 基本信息 */ '@/views/setting/hospital/baseInfo')
// const SettingHospitalMealInfo = () => import(/* 体检信息 */ '@/views/setting/hospital/mealInfo')
// const SettingHospitalMealInfoInfo = () => import(/* 体检信息 */ '@/views/setting/hospital/mealInfo/info/index')
// const SettingHospitalMealInfoSpecialDate = () => import(/* 特殊日期 */ '@/views/setting/hospital/mealInfo/specialDate/index')

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: MainPage,
      redirect: '/home',
      children: [
        {
          path: 'home',
          component: HomePage,
          meta: { title: store.state.organizationName }
        },
        {
          path: 'meal',
          component: Meal,
          meta: { title: '套餐管理' },
          redirect: '/meal/list',
          children: [
            {
              path: 'list',
              component: MealList,
              meta: { title: '套餐列表' }
            },
            {
              path: 'detail',
              component: MealDetail,
              meta: { title: '查看套餐' }
            },
            {
              path: 'medical-item',
              component: MealMedicalItem,
              meta: { title: '体检项目' }
            },
            {
              path: 'medical-detail',
              component: MealMedicalDetail,
              meta: { title: '查看详情' }
            },
            {
              path: 'check-item',
              component: MealCheckItem,
              meta: { title: '检查项目' }
            }
          ]
        },
        {
          path: 'reservation',
          component: Reservation,
          meta: { title: '预约管理' },
          redirect: '/reservation/list',
          children: [
            {
              path: 'list',
              component: ReservationList
            },
            {
              path: 'detail',
              component: ReservationDetail,
              meta: { title: '预约详情' }
            }
          ]
        },
        // {
        //   path: 'report',
        //   component: Report,
        //   meta: { title: '报告申领' },
        //   redirect: '/report/list',
        //   children: [
        //     {
        //       path: 'list',
        //       component: ReportList
        //     },
        //     {
        //       path: 'detail',
        //       component: ReportDetail,
        //       meta: { title: '查看详情' }
        //     }
        //   ]
        // },
        // {
        //   path: 'customer',
        //   component: Customer,
        //   meta: { title: '客户管理' },
        //   redirect: '/customer/list',
        //   children: [
        //     {
        //       path: 'list',
        //       component: CustomerList
        //     }
        //   ]
        // },
        {
          path: 'order',
          component: Order,
          redirect: '/order/list',
          meta: { title: '订单查询' },
          children: [
            {
              path: 'list',
              component: OrderList,
              meta: { title: '订单查询' }
            },
            {
              path: 'detail',
              component: OrderDetail,
              meta: { title: '订单详情' }
            },
            {
              path: 'history',
              component: OrderHistory,
              meta: { title: '交易记录' }
            }
          ]
        }
        // {
        //   path: 'setting',
        //   component: Setting,
        //   redirect: '/setting/hospital/base-info',
        //   children: [
        //     {
        //       path: 'hospital',
        //       component: SettingHospital,
        //       children: [
        //         {
        //           path: 'base-info',
        //           component: SettingHospitalBaseInfo,
        //           meta: { title: '基本信息' }
        //         },
        //         {
        //           path: 'meal-info',
        //           component: SettingHospitalMealInfo,
        //           meta: { title: '体检信息' },
        //           redirect: '/setting/hospital/meal-info/info',
        //           children: [
        //             {
        //               path: 'info',
        //               component: SettingHospitalMealInfoInfo,
        //               meta: { title: '体检信息' }
        //             },
        //             {
        //               path: 'special-date',
        //               component: SettingHospitalMealInfoSpecialDate,
        //               meta: { title: '特殊体检日配置' }
        //             }
        //           ]
        //         }
        //       ]
        //     }
        //   ]
        // }
      ]
    },
    {
      path: '/auth',
      component: Auth,
      redirect: '/auth/login',
      children: [
        {
          name: 'AuthLogin',
          path: 'login',
          component: AuthLogin
        },
        {
          path: 'organization',
          component: AuthOrganization
        },
        {
          path: 'service',
          component: AuthService
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (getToken() || to.name === 'AuthLogin') {
    router.options.routes[0].children[0].meta.title = store.state.organizationName
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    next()
  } else {
    next({
      name: 'AuthLogin'
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js